import { ArrowUpRight } from "lucide-react";

export const AmazonButton = ({ href, label = "Buy on Amazon", variant = "solid", testid, className = "" }) => {
  const base =
    "group inline-flex items-center gap-2 rounded-full px-7 py-3 text-xs uppercase tracking-[0.2em] transition-colors duration-400";
  const variants = {
    solid: "bg-charcoal text-ivory hover:bg-rosegold",
    outline: "border border-charcoal text-charcoal hover:bg-charcoal hover:text-ivory",
    ghostLight: "border border-[#FFF8F0]/70 text-[#FFF8F0] hover:bg-[#FFF8F0] hover:text-charcoal",
  };
  const styles = variants[variant] || variants.solid;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`${base} ${styles} ${className}`}
    >
      {label}
      <ArrowUpRight size={15} className="transition-transform duration-400 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
};

export const ProductCard = ({ product, index = 0 }) => (
  <div className="group" data-testid={`product-card-${product.id}`}>
    <div className="relative overflow-hidden bg-champagne/40 aspect-[4/5]">
      <img
        src={product.image}
        alt={product.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
      />
      <span className="absolute top-4 left-4 text-[0.6rem] uppercase tracking-[0.25em] text-charcoal/50 bg-ivory/80 backdrop-blur-sm rounded-full px-3 py-1">
        {String(index + 1).padStart(2, "0")}
      </span>
    </div>
    <div className="pt-6">
      <h3 className="font-serif text-2xl tracking-tight">{product.name}</h3>
      <p className="mt-2 text-charcoal/60 leading-relaxed text-[0.95rem]">{product.description}</p>
      <p className="mt-3 text-[0.7rem] uppercase tracking-[0.2em] text-rosegold">{product.material}</p>
      <div className="mt-5">
        <AmazonButton
          href={product.amazon}
          variant="outline"
          testid={`product-amazon-${product.id}`}
          label="Buy on Amazon"
        />
      </div>
    </div>
  </div>
);
